import dayjs from 'dayjs';
import React from 'react';
import styled from 'styled-components';
import RighArrow from '~/components/shared/RightArrow/RightArrow';
import {
  FontWeights,
  Typography,
} from '~/components/shared/Typography/Typography';
import { InvoiceStatuses } from '~/enums';
import { formatAmount } from '~/helpers/formatters.helper';
import { SingleInvoice } from '~/Interfaces';
import { theme } from '~/styles/themes';
import { getStatus } from '../InvoicePageBody';

export const SingleItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 8.1em;
  border: 1px solid ${theme.colors.backdrop};
  background-color: white;
  cursor: pointer;
`;

const SingleItemSmallSectionHolder = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SingleItemMediumSectionHolder = styled.div`
  flex: 2;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (orientation: landscape) {
    flex: 1;
  }
`;

const SingleItemLargeSectionHolder = styled.div`
  flex: 4;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 1em;
  @media (orientation: landscape) {
    font-size: ;
  }
`;

const SingleItemDateHolder = styled.div`
  border: 2px solid ${theme.colors.backdrop};
  border-radius: 0.6em;
  height: 4.1em;
  width: 4.1em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

interface Props {
  invoiceData: SingleInvoice;
  onClickHandler: () => void;
}

const ListOfInvoiceSingleItem: React.FC<Props> = (props) => {
  const { invoiceData, onClickHandler } = props;
  const { clientName, dates, totals, invoiceNumber } = invoiceData;

  const statusTranslate: string = getStatus(invoiceData) as string;
  const isStatusColorRed =
    statusTranslate.includes('Förfallen') ||
    statusTranslate.includes('Overdue') ||
    invoiceData.statuses.main === InvoiceStatuses.stopped;

  return (
    <SingleItemContainer onClick={onClickHandler}>
      <SingleItemMediumSectionHolder>
        <SingleItemDateHolder>
          <Typography
            fontSize={0.9}
            fontWeight={500}
            lineHeight={1.3}
            color={theme.colors.newSecondaryGray}
          >
            {dayjs(dates.expireDate).format('MMM').toUpperCase()}
          </Typography>
          <Typography
            fontSize={1}
            fontWeight={FontWeights.Thick}
            lineHeight={1.4}
          >
            {dayjs(dates.invoiceDate).date()}
          </Typography>
        </SingleItemDateHolder>
      </SingleItemMediumSectionHolder>
      <SingleItemLargeSectionHolder>
        <Typography fontSize={1} lineHeight={1.5}>
          {`${clientName} - ${invoiceNumber}`}
        </Typography>
        <Typography
          fontSize={1}
          lineHeight={1.5}
          fontWeight={FontWeights.Thick}
        >
          {formatAmount(totals.totalToPay)}
        </Typography>
        <Typography
          fontSize={0.75}
          lineHeight={1.1}
          color={isStatusColorRed ? theme.colors.error : ''}
        >
          {getStatus(invoiceData)}
        </Typography>
      </SingleItemLargeSectionHolder>
      <SingleItemSmallSectionHolder>
        <RighArrow color={theme.colors.neutral} />
      </SingleItemSmallSectionHolder>
    </SingleItemContainer>
  );
};

export default ListOfInvoiceSingleItem;
